export const commons = {
  languages: {
    A1: 'А1 - Начальный',
    A2: 'А2 - Ниже среднего',
    B1: 'В1 - Средний',
    B2: 'В2 - Выше среднего',
    C1: 'С1 - Продвинутый',
    C2: 'С2 - Профессиональный',
    Native: 'Родной язык'
  },
  roles: {
    club: 'Клуб',
    artist: 'Артист',
    admin: 'Admin'
  },
  artistJobs: {
    Hostess: 'Hostess',
    GoGo: 'GoGo',
    Strip: 'Strip'
  },
  schedule: {
    Monday: 'Понедельник',
    Tuesday: 'Вторник',
    Wednesday: 'Среда',
    Thursday: 'Четверг',
    Friday: 'Пятница',
    Saturday: 'Суббота',
    Sunday: 'Воскресенье'
  },
  paymentFrequency: {
    Daily: 'День',
    Weekly: 'Неделя',
    Monthly: 'Месяц'
  },

  flightPaymentType: {
    Club: 'За счет клуба',
    Artist: 'За счет артиста',
    Credit: 'Кредитация',
    Agreement: 'По договоренности',
    Compensation: 'Компенсация'
  },

  artistConsumation: {
    label: 'Консумация',
    Active: 'Активная',
    Passive: 'Пассивная'
  },

  workItemType: {
    Request: 'Заявки',
    Invite: 'Приглашение'
  },

  workItemStatus: {
    Pending: 'Ожидает',
    Accepted: 'Принято',
    Rejected: 'Отклонено',
    Withdrawn: 'Отозвано',
    Expired: 'Истекло',
    ContractOngoing: 'Контракт действует',
    ContractRequestedEndDate: 'Запрошена дата окончания контракта',
    FinishingContract: 'Контракт заканчивается',
    ContractCompleted: 'Контракт завершён',
    ClubSetEndDate: 'Клуб установил дату окончания',
    Cancelled: 'Отменён'
  },

  artistStatuses: {
    LookingForWork: 'В поиске',
    OnContract: 'На контракте',
    FinishingContract: 'Заканчиваю контракт',
    OnVacation: 'В отпуске',
    HiddenFromSearch: 'Скрыт из поиска'
  },

  loading: {
    generic: 'Данные загружаются...',
    requests: 'Заявки загружаются...',
    invites: 'Приглашения загружаются...'
  },

  flightCompensationOptions: {
    oneMonth: 'За 1 месяц контракта',
    twoMonths: 'За 2 месяца контракта',
    threeMonths: 'За 3 месяца контракта',
    sixMonths: 'За 6 месяцев контракта клуб покупает обратный билет',
    backTicket: 'Обратный билет'
  },

  transportFromAirport: {
    label: 'Транспорт из аэропорта/вокзала',
    options: {
      clubOrganizes: 'Организовывает клуб',
      artistSelf: 'Артистка добирается сама'
    }
  },

  notFound: {
    generic: 'Cписок пуст.',
    requests: 'Заявок пока нет.',
    invites: 'Приглашении пока нет.',
    artists: 'В настоящее время список артистов пуст',
    search:
      'Мы не нашли клуб по вашему запросу :( Сообщите, пожалуйста, об этом нам вподдержку, чтобы мы могли сделать поиск качественнее'
  },

  artistParametres: {
    weight: 'Вес',
    height: 'Рост',
    body: 'Тело',
    chest: 'Обхват груди',
    waist: 'Обхват талии',
    hips: 'Обхват бедер'
  },

  dressCodeOptions: {
    strip: 'Стрипы',
    underwear: 'Белье',
    longDress: 'Длинное платье',
    body: 'Боди',
    shortDress: 'Короткое платье'
  },

  'follow-us-in-social': 'Следите за нами в соц сетях:',
  continue: 'Продолжить',
  'continue-with-google': 'Продолжить с Google',
  artistHiringIsOpen: 'Набор артистов открыт',
  artistHiringIsClosed: 'Набор артистов закрыт',
  acceptWithExperience: 'Принимаем без опыта',
  dontAcceptWithoutExperience: 'Не принимаем без опыта',
  copyLink: 'Копировать ссылку',
  withExperience: 'С опытом',
  withouthExperience: 'Без опыта',
  agree: 'Я соглашаюсь с условиями',
  change: 'Изменить',
  add: 'Добавить',
  citizenship: 'Гражданство',
  save: 'Сохранить',
  'save-and-continue': 'Сохранить и продолжить',
  edit: 'Редактировать',
  portfolio: 'Портфолио',
  close: 'Закрыть',
  closed: 'Закрыто',
  finish: 'Завершить',
  help: 'Помощь',
  logout: 'Выйти',
  country: 'Страна',
  deleteAccount: 'Удалить аккаунт',
  changePassword: 'Изменить пароль',
  hide: 'Скрыть',
  delete: 'Удалить',
  exit: 'Да, я хочу выйти',
  'undo-to-account': 'Обратно в аккаунт',
  location: 'Местоположение',
  language: 'Языки',
  parametres: 'Параметры',
  about: 'О себе',
  my: 'Мои',
  photo: 'Фото',
  video: 'Видео',
  experience: 'Опыт',
  galery: 'Галерея',
  write: 'Написать',
  yes: 'Да',
  step: 'Шаг',
  no: 'Нет',
  or: 'Или',
  resend: 'Переслать',
  open: 'открыть',
  cancel: 'Отменить',
  need: 'Нужна',
  dontNeed: 'Не нужна',
  endWork: 'Конец работы',
  startDate: 'Дата начала работы',
  endDate: 'Дата конца работы',
  vacancy: 'Вакансия',
  creditation: 'Кредитация билета',
  aroundTheClock: 'Круглосуточно',
  flightTickets: 'Авиабилеты',
  ticketCreditation: 'Кредитация билета',
  crazyMenu: 'Crazy меню',
  tea: 'Чай',
  show: 'Шоу',
  deposit: 'Депозит',
  guarantee: 'Гарантия',
  rate: 'Ставка',
  clubFee: 'Клубный сбор',
  separated: 'Раздельные',
  forShift: 'За смены',
  required: 'Обязательно',
  optional: 'Не обязательно',
  quantity: 'Количество',
  withouthExprience: 'Без опыта',
  choreographerInClub: 'Наличие хореографа в клубе',
  photoshootParticipation: 'Участие в фотосессиях',
  artistsInShift: 'Артисток в смене',
  scenes: 'Сцен',
  dynamicPole: 'Пилонов динамика',
  staticPole: 'Пилонов статика',
  artistTraining: 'Обучение артисток',
  teching: 'Обучение',
  dressCodeForArtists: 'Дресс код для артисток',
  dressCode: 'Дресс код',
  rentPayment: 'Оплата жилья',
  utilitiesPayment: 'Оплата комунальных',
  clubProvidedAccommodation: 'Проживание артиста в жилье от клуба',
  housingPhoto: 'Фото жилья',
  noteEditLater: 'Позже вы сможете внести изменения',
  paydByArtist: 'Артисткой',
  paydByClub: 'Клубом',
  peopleInRoom: 'Человек в комнате до',
  uploadFromDevice: 'Загрузить с устройства',
  uploadManyFromDevice: 'Загрузите несколько фото с устройства',
  selectMainPhoto: 'Выбрать главное фото',
  photoParams: 'Размер фотографии не должен превышать {size} МБ',
  videoParams:
    'Размер видео не должен превышать {size} МБ, поддерживаемыеформаты: MP4, QuickTime,',
  general: 'Общие',
  payments: 'Выплаты',
  full: 'Фулл',
  topless: 'Топлес',
  gogo: 'Го-го',
  crazymenu: 'Крейзи меню',
  continueFilling: 'Продолжить заполнение',
  search: 'Поиск',
  other: 'Другое',
  foreignLanguages: 'Иностранные языки',
  dancer: 'Танцовщица',
  untilNow: 'До настоящего времени',
  invite: 'Пригласить',
  cancelInvite: 'Отменить приглашение',
  dateFormatPlaceholder: 'дд.мм.гг',
  askArtist: 'Задать вопрос артисту',
  askClub: 'Задать вопрос клубу',
  reject: 'Отклонить',
  accept: 'Принять',
  confirm: 'Подтвердить',
  iConfirm: 'Подтвердить',
  workAt: 'Работает с',
  setLastDate: 'Установите последнюю дату',
  lastWorkDay: 'Последний день работы',
  cancelArrangement: 'Отменить договоренность',
  back: 'Назад',
  wantedVacancy: 'Желаемые вакансии',
  addClub: ' Добавить клуб',
  goToInvitation: 'Перейти к приглашению',
  goToRequest: 'Перейти к запросу',
  vacancyConsider: 'Какие вакансии рассматриваете?',
  super: 'Супер',
  clubLocation: 'Местоположение клуба',
  specify: 'Указать',
  housing: 'Жилье',
  position: 'Позиция',
  guest: 'Гость',
  workingHours: 'Часы работы',
  isPaydByClub: 'Оплачивается клубом',
  isntPaydByClub: 'Не оплачивается клубом',
  utilityPayments: 'Оплата коммунальных',
  payment: 'Оплата',
  request: 'Запросить',
  penalties: 'Штрафы',
  aboutClub: 'О клубе',
  sendRequest: 'Подать заявку',
  cancelRequest: ' Отменить заявку',
  profile: 'Профиль',
  chat: 'Чат',
  housigInClubApartsRequired: 'Проживание в жилье от клуба обязательно'
};
